import React from 'react';
import { ItemCard } from '@leverege/ui-attributes';
import { Config } from '@leverege/plugin';
import { Content } from '@leverege/ui-elements';
import { GridLoader } from 'react-spinners';
import { Toolbar } from '@leverege/ui-plugin';
import { connect } from 'react-redux';
import { HeaderToolbar } from "../Util.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DetailsView(props) {
  const Loader = Config.get('LoadingScreen', 'spinner', GridLoader);
  const {
    settings,
    onSettingsChange,
    settingsData,
    item,
    cardHeightAuto,
    delegate,
    objectType,
    relationship: {
      path
    },
    inCard,
    overrideModel
  } = props;
  const loaderProps = Config.get('LoadingScreen', 'props', {});
  const editable = (overrideModel?.editable != null ? overrideModel.editable : null) || false;
  const clientProps = {
    ...props,
    settings,
    settingsData: 'setSettings',
    onSettingsChange: evt => {
      onSettingsChange({
        value: evt.value,
        data: settingsData
      });
    }
  };
  const context = {
    id: item?.id,
    target: [{
      id: item?.id,
      ref: delegate.parent().getInterfaceUrl(),
      type: objectType,
      data: item
    }],
    clientProps,
    editable
  };
  if (!item) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        height: 150,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx(Loader, {
        size: 20,
        color: loaderProps.color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
      })
    });
  }
  const matchContext = {
    use: 'actionBar',
    client: DetailsView.CLIENT,
    objectType,
    path
  };
  const content = /*#__PURE__*/_jsx(Toolbar, {
    variant: "actionBar",
    prefer: "icon",
    context: context,
    matchContext: matchContext
  });
  return /*#__PURE__*/_jsxs(Content, {
    relative: cardHeightAuto,
    children: [/*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(ItemCard, {
        model: settings,
        context: context
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      layout: "flex:rowMEnd",
      children: /*#__PURE__*/_jsx(HeaderToolbar, {
        inCard: inCard,
        content: content
      })
    })]
  });
}
export default connect((state, ownProps) => {
  const {
    delegate
  } = ownProps;
  return {
    // need to pass this in to force re-render
    canSet: delegate.canUpdate()
  };
})(DetailsView);
DetailsView.CLIENT = 'molten.dataViewer.details.DetailsItemInfoDataViewer'; // 'DataCardViewer'